import { datadogRum } from "@datadog/browser-rum";

if (process.env.RAILS_ENV !== "development" && process.env.RAILS_ENV !== "test") {
  datadogRum.init({
    applicationId: process.env.DATADOG_APPLICATION_ID,
    clientToken: process.env.DATADOG_CLIENT_TOKEN,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: "datadoghq.com",
    service: "promote",
    env: process.env.RELEASE_STAGE || process.env.RAILS_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: "mask-user-input"
  });
}
